/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "eventapi",
            "endpoint": "https://vgu7bghf6b.execute-api.us-east-1.amazonaws.com/master",
            "region": "us-east-1"
        },
        {
            "name": "llmpublicapi",
            "endpoint": "https://sszmqgwfpk.execute-api.us-east-1.amazonaws.com/master",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://wulbejnpszaffhkbpjnpjfaage.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "us-east-1:6b3105de-be3b-4485-8352-047a3706632e",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_xwnod6jD9",
    "aws_user_pools_web_client_id": "4blnmogh6f8i90kcqeu8tc79oa",
    "oauth": {
        "domain": "llmasaserviceadmin2e6777d0-2e6777d0-master.auth.us-east-1.amazoncognito.com",
        "scope": [
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/login/,https://app.llmasaservice.io/login/",
        "redirectSignOut": "http://localhost:3000/login/,https://app.llmasaservice.io/login/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_AND_IDENTITY_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS",
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "llmagentdocumentstorage222110-master",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
